import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { useCallback, useState } from "react";

import { useSmOrMdScreenMediaQuery } from "@/react/hooks/useMediaQuery";

import {
  MIN_TABS_CONTAINER_WIDTH,
  MIN_TABS_CONTAINER_WIDTH_V2,
} from "./constants";

export const useNotificationsWidth = () => {
  const { currentCommunitySettings } = usePunditUserContext();
  const isNotificationsTabV2Enabled = Boolean(
    currentCommunitySettings?.live_pulse_notifications_tab_v2_enabled,
  );

  const minWidth = isNotificationsTabV2Enabled
    ? MIN_TABS_CONTAINER_WIDTH_V2
    : MIN_TABS_CONTAINER_WIDTH;

  const [tabsContainerWidth, setTabsContainerWidth] = useState(minWidth);
  const isSmallScreen = useSmOrMdScreenMediaQuery();

  const tabsContainerRef = useCallback(
    (node: HTMLDivElement | null) => {
      if (isSmallScreen) {
        setTabsContainerWidth(window.innerWidth);
      } else if (node) {
        setTabsContainerWidth(Math.max(node.offsetWidth, minWidth));
      }
    },
    [isSmallScreen, minWidth],
  );

  return { tabsContainerWidth, tabsContainerRef };
};
